import { Card, makeStyles, Typography } from '@material-ui/core';
import React, { FC } from 'react';
import { Box } from '@material-ui/core';
import { Theme } from 'src/theme';
import SingleValue from './Loaders/SingleValue';

interface DataTileProps {
  title?: string;
  data?: number | string;
  loading?: boolean;
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(3),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
}));
const DataTile: FC<DataTileProps> = ({ title = 'Title', data = 0, loading = false }) => {
  const classes = useStyles();

  return (
    <Card
      className={classes.root}
    >
      <Box flexGrow={1}>
        <Typography
          component="h3"
          gutterBottom
          variant="overline"
          color="textSecondary"
        >
          {title}
        </Typography>
        <Box
          display="flex"
          alignItems="center"
          flexWrap="wrap"
        >
          <Typography
            variant="h3"
            color="textPrimary"
          >
            {loading ? <SingleValue width="20%" valueHeight={10} /> : data}
          </Typography>
        </Box>
      </Box>
    </Card>
  );
};

export default DataTile;
